import { Box, Divider, Stack, Typography } from '@mui/material'

interface Props {
  title: string
  value: string
  additionalItem?: JSX.Element
  variant?: 'h6'
}

const SummaryPanelTableRow = ({
  title,
  value,
  additionalItem,
  variant
}: Props) => {
  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant={variant}>{title}</Typography>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ mt: -1, mb: -1 }}>
          {additionalItem}
          <Typography
            minWidth={'8ch'}
            maxWidth={'8ch'}
            textAlign={'right'}
            variant={variant}>
            {value}
          </Typography>
        </Stack>
      </Stack>
      <Divider />
    </Box>
  )
}

export default SummaryPanelTableRow
